import React, { createContext, useContext, useState } from 'react';

const WatchlistSearchStateContext = createContext();
const WatchlistSearchToggleContext = createContext();

const useWatchlistSearch = () => {
    const [showSearch, tooggleSearch] = useState(false);
    return [showSearch, tooggleSearch];
};

export function useWatchlistSearchState() {
    const context = useContext(WatchlistSearchStateContext);
    if (context === undefined) {
        throw new Error(
            'useWatchlistSearchState must be used within a WatchlistSearchProvider'
        );
    }
    return context;
}

export function useWatchlistSearchToggle() {
    const context = useContext(WatchlistSearchToggleContext);
    if (context === undefined) {
        throw new Error(
            'useWatchlistToggleState must be used within a WatchlistSearchProvider'
        );
    }
    return context;
}

export function WatchlistSearchProvider({ children }) {
    const [showSearch, toggleSearch] = useWatchlistSearch();
    return (
        <WatchlistSearchStateContext.Provider value={showSearch}>
            <WatchlistSearchToggleContext.Provider value={toggleSearch}>
                {children}
            </WatchlistSearchToggleContext.Provider>
        </WatchlistSearchStateContext.Provider>
    );
}

export default useWatchlistSearch;
